<template>
  <component
    :is="mapType[type]"
    v-bind="componentProps"
    :disabled="disabled"
  />
</template>

<script>

import _ from 'lodash'
import EventBus from '@/eventBus'

export default {
  name: 'BlockEditor',
  components: {
    RichTextBlock: () => import('./RichTextBlock.vue'),
    ImageBlock: () => import('./ImageBlock.vue'),
    EmojiBlock: () => import('./EmojiBlock.vue'),
    LineBlock: () => import('./LineBlock.vue'),
    ShapeBlock: () => import('./ShapeBlock.vue'),
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    componentData: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mapType: {
        RichText: 'RichTextBlock',
        Image: 'ImageBlock',
        Emoji: 'EmojiBlock',
        Shape: 'ShapeBlock',
        Line: 'LineBlock',
      },
    }
  },
  computed: {
    componentProps() {
      let transformData = { }
      const transformDataFunc = this[`transformDataType${this.type}`]
      if (transformDataFunc) {
        transformData = transformDataFunc()
      }
      return {
        ...transformData,
        blockStyle: {
          width: _.get(this.componentData, 'style.width'),
          height: _.get(this.componentData, 'style.height'),
          transform: _.get(this.componentData, 'style.transform'),
        },
        blockContent: _.get(this.componentData, 'content'),
        blockId: this.componentData.id,
        slideId: this.componentData.slideId,
        preview: this.preview,
      }
    },
  },
  methods: {
    transformDataTypeRichText() {
      return {
        value: _.get(this.componentData, 'content.value'),
      }
    },
    transformDataTypeImage() {
      return _.get(this.componentData, 'content')
    },
    transformDataTypeEmoji() {
      return _.get(this.componentData, 'content')
    },
    transformDataTypeShape() {
      return _.get(this.componentData, 'content')
    },
    onRichTextEditorUpdate(textUpdate) {
      this.$emit('update-content', {
        value: textUpdate,
      })
    },
    onRichTextEditorInitBlur() {
      EventBus.$emit('inputInitBlurComplete', this.componentData.id)
    },
    ready(slideId) {
      this.$emit('ready', slideId)
    },
  },
}
</script>

<style scoped>

</style>
